import { useQuery } from 'react-query';

import { getV2ApiCompanyIdBudgetDefinitions } from 'src/client/spendesk-api';
import { useCompany } from 'src/core/modules/app/hooks/useCompany';

import {
  type ApiBudgetDefinition,
  convertApiToBudgetDefinition,
} from './budgetDefinition';
import { getApiKey } from './keys';

export const useGetBudgetDefinitions = () => {
  const company = useCompany();
  return useQuery(
    getApiKey(),
    async () => {
      const response = await getV2ApiCompanyIdBudgetDefinitions({
        path: { companyId: company.id },
      });

      if (response.statusCode !== 200) {
        throw new Error('Failed to get budget definitions');
      }
      return response.body.map((definition) =>
        convertApiToBudgetDefinition(definition as ApiBudgetDefinition),
      );
    },
    {
      retry: false,
    },
  );
};
